import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ReportHeaderData } from '../../models/ReportHeaderData';

@Component({
  selector: 'app-report-header',
  templateUrl: './report-header.component.html',
  styleUrls: ['./report-header.component.scss'],
})
export class ReportHeaderComponent {
  @Input() data: ReportHeaderData[];
  @Input() extraFieldVisible: boolean;
  @Input() extraFieldValue: string;
  @Output() extraFieldValueChange = new EventEmitter<string>();

  constructor() {}

  change(newValue: string): void {
    this.extraFieldValue = newValue;
    this.extraFieldValueChange.emit(newValue);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/report-header/report-header.component.ts